<template>
	<div class="statisticalBox">
		<h3>已完成案件</h3>
		<div class="timeBox">
		  <p><span>{{timeNow}}</span></p>
		  <div class="block">
		    <el-date-picker
		      v-model="time"
		      type="month"
		      @change='changeFun'
		      placeholder="选择月">
		    </el-date-picker>
		  </div>		  
		</div>
		<div class="canvasBox">
			<div class="canvas1">
				<p>各类型案件数量占比</p>
				<canvas id="chart" height="800" width="1000" v-show="nonedataShow">该浏览器不支持此插件，请升级或者换浏览器登录浏览</canvas>
				<!--<p class="text1" >暂无数据</p>-->
				<img class="text1"  v-show='!nonedataShow' src="./img/case.png">
			</div>
			<div class="canvas1">
				<p>各类型案件金额占比</p>
				<canvas id="chart1" height="800" width="1000" v-show="nonedataShow">该浏览器不支持此插件，请升级或者换浏览器登录浏览</canvas>
				<!--<p class="text1" v-show='!nonedataShow'>暂无数据</p>-->
				<img class="text1"  v-show='!nonedataShow' src="./img/money.png">
			</div>
		</div>
		<div class="tabBox">
			<h3>案件分类</h3>
			<div class="top">
				<ul>
					<li :class="{active:listIndex == index}" v-for="(item,index) in titleName" @click="listIndex = index;fenleiId=item.id;getAllcase(item.id)">{{item.name}}</li>
				</ul>
			</div>
			<div class="tableBox">
				<table width="100%" border="0" cellpadding="0" cellspacing="0">
					<thead>
						<tr>
							<th v-for="item in titleList">{{item}}</th>
						</tr>
					</thead>	
					<tbody>
						<tr v-for="(item,index) in caseList" v-if="caseList.length != 0">
							<td>{{index + 1}}</td>
							<td>{{typenameFun(item.obj.incidentType)}}</td>
							<td>{{item.obj.caseNo}}</td>
							<td>{{item.caseCountry}} {{item.caseCity}}</td>
							<td>{{item.victimList[0].obj.victimName || '无'}}</td>
							<td>{{item.obj.incidentTs}}</td>
							<td>{{item.victimList[0].obj.insurancePolicyNo || '无'}}</td>
							<td>{{item.obj.caseSrc || '未填写'}}</td>
							<td>案件已完成</td>
							<td>{{setTIme(item.obj.incidentTs)}}</td>
							<td><router-link :to="{name:'RegFinishPar2',query:{caseid:item.obj.id,tj:'1'}}">查看详情</router-link></td>
						</tr>
					</tbody>
				</table>
				<p class="text" v-if="caseList.length == 0">暂无数据</p>
			</div>
		</div>
	</div>
</template>
<script>
	import { getstatisticalData,getstatisticalMonthCase,seversList } from '@/views/axios/api.js';
	import constants from "@/util/constants.js";
	export default{
		data(){
			return{
				token:JSON.parse(window.localStorage.getItem("data")).data,
				chartData : [],
		        chartData1 : [],
		        
		        color:['#4c5060','#fc585c','#fcb45c','#44bcbc','#949cb0','#5a9ef2'],
		        color1:['#7b7b7b','#f36b6f','#f88745','#fdbd15','#58acd0'],
		        time:'',
		        timeNow:'',
		        titleName:['全部','医疗救援','门急诊就医','住院安排','转运/送返','其他'],
		        titleList:['序号','案件类型','案件编号','发生地点','用户姓名','用户手机号','证件信息','案件来源','当前状态','完成时间','操作'],
		        listIndex:0,
		        caseList:[],
		        fenleiId:'',
		        nonedataShow:true
			}
		},
		mounted(){
			this.getDate();
			var dateTime = new Date();
			var dataMonth =parseInt(dateTime.getMonth()+ 1)  < 10 ? '0'+parseInt(dateTime.getMonth()+ 1)  : parseInt(dateTime.getMonth()+ 1) 
			this.timeNow=`${dateTime.getFullYear()}年${dataMonth}月`;	
			this.getAllcase();
			this.getSeverFun()
		},
		methods:{
			setTIme(time){
				return constants.time(time)
			},
			typenameFun(id){
				var arr =this.titleName.find(item=>{
					return item.id == id
				})
				return arr.name
			},
			getDate(time){
				var data={
					token:this.token,
					yearMonth:time
				}
				getstatisticalData(data)
				.then(res=>{
					var data=res.data.obj.fee;
					var data1=res.data.obj.type;
					this.chartData=this.dataFormatting(data1,this.color);
					this.chartData1=this.dataFormatting(data,this.color1);
					this.goChart(this.chartData,'chart')
					this.goChart(this.chartData1,'chart1')
				})
				.catch(err=>{
					console.log(err)
				})
			},
			getAllcase(status,time){
				var data={
					token:this.token,
					yearMonth:String(this.setTimeFun().dataYear) + String(this.setTimeFun().dataMonth),
					status
				}
				getstatisticalMonthCase(data)
				.then(res=>{
					this.caseList=res.data.obj;
					if(this.caseList.length == 0){
						this.nonedataShow=false
					}else{
						this.nonedataShow=true
					}
				})
				.catch(err=>{
					console.log(err)
				})
			},
			getSeverFun(){//获取分类
				var data={
			        token:this.token,
					parentId:0					
				}
				seversList(data)
				.then(res=>{
					this.titleName=res.data.obj
					this.titleName.unshift({name:'全部',})
				})
				.catch(err=>{
					console.log(err)
				})
			},
			dataFormatting(data,color){
				var arr=[]
				data.forEach((item,index)=>{
					item.color=color[index];
					arr.push([item.num,item.color,item.name])
				})
				
				return arr
			},
			changeFun(){
				this.timeNow=`${this.setTimeFun().dataYear} 年 ${this.setTimeFun().dataMonth} 月`;
				var time =String(this.setTimeFun().dataYear) + String(this.setTimeFun().dataMonth)
				this.getDate(time);
				this.getAllcase(this.fenleiId,time)
				
			},
			setTimeFun(){
				var dateTime = new Date(this.time);
				var dataMonth =parseInt(dateTime.getMonth()+ 1)  < 10 ? '0'+parseInt(dateTime.getMonth()+ 1)  : parseInt(dateTime.getMonth()+ 1);
				var dataYear = dateTime.getFullYear()
				return { dataYear,dataMonth }
			},
	        goChart(dataArr,idname){	            
	            // 声明所需变量
	            var canvas,ctx;
	            // 图表属性
	            var cWidth, cHeight, cMargin, cSpace;
	            // 饼状图属性
	            var radius,ox,oy;//半径 圆心
	            var tWidth, tHeight;//图例宽高
	            var posX, posY, textX, textY;
	            var startAngle, endAngle;
	            var totleNb;
	            // 运动相关变量
	            var ctr, numctr, speed;
	            //鼠标移动
	            var mousePosition = {};
	            
	            //线条和文字
	            var lineStartAngle,line,textPadding,textMoveDis,rotateAngle,new_data_arr,totalYNomber,yMove;
	        
	            // 获得canvas上下文
	            canvas = document.getElementById(idname);
	            if(canvas && canvas.getContext){
	                ctx = canvas.getContext("2d");
	            }
	            initChart(); 
	            
	            // 图表初始化
	            function initChart(){
	                // 图表信息
	                cMargin = 600;
	                cSpace = -60;
//	                
//	                canvas.width = canvas.parentNode.getAttribute("width")* 2 ;
//	                canvas.height = canvas.parentNode.getAttribute("height")* 2;
	                canvas.style.height = canvas.height/2 + "px";
	                canvas.style.width = canvas.width/2 + "px";
	                cHeight = canvas.height - cMargin*2;
	                cWidth = canvas.width - cMargin*2;
	        
	                //饼状图信息
//	                radius = cHeight*2/6;  //半径  高度的2/6
	                radius = 200
	                ox = canvas.width/2 + cSpace;  //圆心
//	                oy = canvas.height/2;
	                oy = 280;
	                tWidth = 20; //图例宽和高
	                tHeight = 20; 
	                posX = cMargin+50;
	                posY = cMargin-40;   //
	                textX = posX + tWidth + 15
	                textY = posY + 18;
	                startAngle = endAngle = 90*Math.PI/180; //起始弧度 结束弧度
	                rotateAngle = 0; //整体旋转的弧度
	    
	                //将传入的数据转化百分比
	                totleNb = 0;
	                new_data_arr = [];
	                for (var i = 0; i < dataArr.length; i++){
	                    totleNb += dataArr[i][0];
	                }
	                for (var i = 0; i < dataArr.length; i++){
	                    new_data_arr.push( dataArr[i][0]/totleNb );
	                }
	                totalYNomber = 10;
	                // 运动相关
	                ctr = 1;//初始步骤
	                numctr = 50;//步骤
	                speed = 1.2; //毫秒 timer速度
	                
	                //指示线 和 文字
	                lineStartAngle = -startAngle;
	                line=30;         //画线的时候超出半径的一段线长
	                textPadding=10;  //文字与线之间的间距
	                textMoveDis = 200; //文字运动开始的间距
	            }
	        
	            drawMarkers();
	            //绘制比例图及文字
	            function drawMarkers(){
	                ctx.textAlign="left";
	                for (var i = 0; i < dataArr.length; i++){
	                    //绘制比例图及文字
	                    ctx.fillStyle = dataArr[i][1];
	                    ctx.fillRect(posX, posY + 40 * i, tWidth, tHeight);
	                    ctx.moveTo(posX, posY + 40 * i);
	                    ctx.font = 'normal 24px 微软雅黑';    //斜体 30像素 微软雅黑字体
	                    ctx.fillStyle = dataArr[i][1]; //"#000000";
	                    var percent = dataArr[i][2] + "：" + (100 * new_data_arr[i]).toFixed(2) + "% ";
	                    ctx.fillText(percent, textX, textY + 40 * i);
	                }
	            };
	            //绘制动画
	            pieDraw();
	            function pieDraw(mouseMove){
	                
	                for (var n = 0; n < dataArr.length; n++){
	                    ctx.fillStyle = ctx.strokeStyle = dataArr[n][1];
	                    ctx.lineWidth=1;
	                    var step = new_data_arr[n]* Math.PI * 2; //旋转弧度
	                    var lineAngle = lineStartAngle+step/2;   //计算线的角度
	                    lineStartAngle += step;//结束弧度
	                    
	                    ctx.beginPath();
	                    var  x0=ox+radius*Math.cos(lineAngle),//圆弧上线与圆相交点的x坐标
	                         y0=oy+radius*Math.sin(lineAngle),//圆弧上线与圆相交点的y坐标
	                         x1=ox+(radius+line)*Math.cos(lineAngle),//圆弧上线与圆相交点的x坐标
	                         y1=oy+(radius+line)*Math.sin(lineAngle),//圆弧上线与圆相交点的y坐标
	                         x2=x1,//转折点的x坐标
	                         y2=y1,
	                         linePadding=ctx.measureText(dataArr[n][2]).width+10; //获取文本长度来确定折线的长度
	                         
	                         ctx.moveTo(x0,y0);
	                         //对x1/y1进行处理，来实现折线的运动
	                         yMove = y0+(y1-y0)*ctr/numctr;
	                         ctx.lineTo(x1,yMove);
	                         if(x1<=x0){
	                             x2 -= line;
	                             ctx.textAlign="right";
	                             ctx.lineTo(x2-linePadding,yMove);
	                            ctx.fillText(dataArr[n][2],x2-textPadding-textMoveDis*(numctr-ctr)/numctr,y2-textPadding);
	                            ctx.fillText(dataArr[n][0]+ '例('+(100 * new_data_arr[n]).toFixed(2) + "%) ",x2-textPadding-textMoveDis*(numctr-ctr)/numctr,y2-textPadding+40);
	                         }else{
	                             x2 += line;
	                             ctx.textAlign="left";
	                             ctx.lineTo(x2+linePadding,yMove);
	                            ctx.fillText(dataArr[n][2],x2+textPadding+textMoveDis*(numctr-ctr)/numctr,y2-textPadding);
	                            ctx.fillText(dataArr[n][0]+ '例('+(100 * new_data_arr[n]).toFixed(2) + "%) ",x2+textPadding+textMoveDis*(numctr-ctr)/numctr,y2-textPadding+40);
	                         }
	                         
	                        ctx.stroke();
	                        
	                }
	                
	                //设置旋转
	                ctx.save();
	                ctx.translate(ox, oy);
	                ctx.rotate((Math.PI*2/numctr)*ctr/2);
	                
	                //绘制一个圆圈
	//              ctx.strokeStyle = "rgba(0,0,0,"+ 0.5*ctr/numctr +")"
	//              ctx.beginPath();
	//              ctx.arc(0, 0 ,(radius+20)*ctr/numctr, 0, Math.PI*2, false);
	//              ctx.stroke();
	                
	                for (var j = 0; j < dataArr.length; j++){
	                    
	                    //绘制饼图
	                    endAngle = endAngle + new_data_arr[j]* ctr/numctr * Math.PI * 2; //结束弧度
	                    
	                    ctx.beginPath();
	                    ctx.moveTo(0,0); //移动到到圆心
	                    ctx.arc(0, 0, radius*ctr/numctr, startAngle, endAngle, false); //绘制圆弧
	                    
	                    ctx.fillStyle = dataArr[j][1];
	                    if(mouseMove && ctx.isPointInPath(mousePosition.x*2, mousePosition.y*2)){
	                        ctx.globalAlpha = 0.8;
	                    }
	                    
	                      ctx.closePath();
	                      ctx.fill();
	                    ctx.globalAlpha = 1;
	                    
	                    startAngle = endAngle; //设置起始弧度
	                    if( j == dataArr.length-1 ){
	                        startAngle = endAngle = 90*Math.PI/180; //起始弧度 结束弧度
	                    }
	                }
	                
	                ctx.restore();
	                    
	                if(ctr<numctr){
	                    ctr++;
	                    setTimeout(function(){
	                        //ctx.clearRect(-canvas.width,-canvas.width,canvas.width*2, canvas.height*2);
	                        ctx.clearRect(-canvas.width, -canvas.height,canvas.width*2, canvas.height*2);
	                        drawMarkers();
	                        pieDraw();
	                    }, speed*=1.085);
	                }
	            }
	            
	            //监听鼠标移动
	            var mouseTimer = null;
	            canvas.addEventListener("mousemove",function(e){
	                e = e || window.event;
	                if( e.offsetX || e.offsetX==0 ){
	                    mousePosition.x = e.offsetX;
	                    mousePosition.y = e.offsetY;
	                }else if( e.layerX || e.layerX==0 ){
	                    mousePosition.x = e.layerX;
	                    mousePosition.y = e.layerY;
	                }
	                
	                clearTimeout(mouseTimer);
	                mouseTimer = setTimeout(function(){
	                    ctx.clearRect(0,0,canvas.width, canvas.height);
	                    drawMarkers();
	                    pieDraw(true);
	                },10);
	            });
	            
	        }			
		}
	}
</script>
<style scoped="scoped">
	.canvasBox{overflow: hidden;}
	.canvasBox >div{float: left;width: 50%;}
	.canvas1 p{font-size: 16px;color: #333;text-indent: 160px;}
	.timeBox{padding-bottom: 50px;position: relative;}
	.timeBox p{text-align: center;font-size: 20px;}
	.timeBox p >span{background: url(./img/err2.png) no-repeat right center;padding-right: 30px;cursor: pointer;}
	.timeBox .block{position: absolute;top: 0;left: 50%;margin-left: -100px;opacity: 0;}
	.timeBox .block input{cursor: pointer;}
	.tabBox .top{overflow: hidden;background: #f2f5f8;padding: 2px;width: 820px;margin: 0 auto;}
	.tabBox .top li{float: left;line-height: 30px;padding:0 20px;cursor: pointer;}
	.active{background: white;color: #44c1fb;}
	.tableBox{margin-top: 10px;}
	.tableBox thead{background: #f5f7fb;color: #333;}
	.tableBox th{font-size: 14px;color: #333;height: 50px;}
	.tableBox td{border-bottom: 1px solid #d9ddde;border-right: 1px solid #d9ddde;text-align: center;font-size: 12px;height: 50px;word-wrap : break-word;padding: 0 5px}
	.tableBox a{text-decoration: none;color: #00abfa;}
	.text{text-align: center;font-size: 14px;color: #666;margin-top: 20px;}
	.text1{margin: 20px auto;margin-left: 30px;}
	.tableBox tr td:first-child{border-left: 1px solid #d9ddde;}
</style> 


// WEBPACK FOOTER //
// src/views/commonPage/statistical.vue